import {
    TLD_AUSTRALIA,
    TLD_CANADA,
    TLD_DEUTSCHLAND,
    TLD_GLOBALLY,
    TLD_UNITED_KINGDOM,
    TLD_UNITED_STATES,
} from '../../../../constants/constants';

export type topDestination = {
    displayName: string;
    locationSlug: string;
    imageUrl: string;
};

export const TOP_DESTINATIONS: Record<
    string,
    Omit<topDestination, 'imageUrl'>[]
> = {
    [TLD_UNITED_STATES]: [
        {
            locationSlug: 'ny--new-york',
            displayName: 'New York',
        },
        {
            locationSlug: 'ca--los-angeles',
            displayName: 'Los Angeles',
        },
        {
            locationSlug: 'il--chicago',
            displayName: 'Chicago',
        },
        {
            locationSlug: 'dc--washington',
            displayName: 'Washington',
        },
        {
            locationSlug: 'ga--atlanta',
            displayName: 'Atlanta',
        },
        {
            locationSlug: 'tx--dallas',
            displayName: 'Dallas',
        },
        {
            locationSlug: 'tx--houston',
            displayName: 'Houston',
        },
        {
            locationSlug: 'ca--san-francisco',
            displayName: 'San Francisco',
        },
        {
            locationSlug: 'fl--miami',
            displayName: 'Miami',
        },
        {
            locationSlug: 'ma--boston',
            displayName: 'Boston',
        },
        {
            locationSlug: 'nv--las-vegas',
            displayName: 'Las Vegas',
        },
        {
            locationSlug: 'nc--charlotte',
            displayName: 'Charlotte',
        },
        {
            locationSlug: 'fl--orlando',
            displayName: 'Orlando',
        },
        {
            locationSlug: 'pa--philadelphia',
            displayName: 'Philadelphia',
        },
        {
            locationSlug: 'ca--san-diego',
            displayName: 'San Diego',
        },
    ],
    [TLD_DEUTSCHLAND]: [
        {
            locationSlug: 'germany--berlin',
            displayName: 'Berlin',
        },
        {
            locationSlug: 'germany--frankfurt-am-main',
            displayName: 'Frankfurt Am Main',
        },
        {
            locationSlug: 'germany--m%C3%BCnchen',
            displayName: 'München',
        },
        {
            locationSlug: 'germany--hamburg',
            displayName: 'Hamburg',
        },
        {
            locationSlug: 'germany--k%C3%B6ln',
            displayName: 'Köln',
        },
        {
            locationSlug: 'germany--d%C3%BCsseldorf',
            displayName: 'Düsseldorf',
        },
        {
            locationSlug: 'germany--nordrhein-westfalen',
            displayName: 'Nordrhein-Westfalen',
        },
        {
            locationSlug: 'germany--stuttgart',
            displayName: 'Stuttgart',
        },
        {
            locationSlug: 'netherlands--amsterdam',
            displayName: 'Amsterdam',
        },
        {
            locationSlug: 'germany--leipzig',
            displayName: 'Leipzig',
        },
        {
            locationSlug: 'united-kingdom--london',
            displayName: 'London',
        },
        {
            locationSlug: 'germany--mannheim',
            displayName: 'Mannheim',
        },
        {
            locationSlug: 'germany--dortmund',
            displayName: 'Dortmund',
        },
        {
            locationSlug: 'germany--hannover',
            displayName: 'Hannover',
        },
        {
            locationSlug: 'germany--n%C3%BCrnberg',
            displayName: 'Nürnberg',
        },
    ],
    [TLD_CANADA]: [
        {
            locationSlug: 'canada--toronto',
            displayName: 'Toronto',
        },
        {
            locationSlug: 'canada--vancouver',
            displayName: 'Vancouver',
        },
        {
            locationSlug: 'canada--montreal',
            displayName: 'Montreal',
        },
        {
            locationSlug: 'canada--ottawa',
            displayName: 'Ottawa',
        },
        {
            locationSlug: 'canada--calgary',
            displayName: 'Calgary',
        },
        {
            locationSlug: 'canada--edmonton',
            displayName: 'Edmonton',
        },
        {
            locationSlug: 'canada--mississauga',
            displayName: 'Mississauga',
        },
        {
            locationSlug: 'canada--ontario',
            displayName: 'Ontario',
        },
        {
            locationSlug: 'canada--winnipeg',
            displayName: 'Winnipeg',
        },
        {
            locationSlug: 'canada--victoria',
            displayName: 'Victoria',
        },
        {
            locationSlug: 'canada--hamilton',
            displayName: 'Hamilton',
        },
        {
            locationSlug: 'canada--halifax',
            displayName: 'Halifax',
        },
        {
            locationSlug: 'canada--london',
            displayName: 'London',
        },
        {
            locationSlug: 'canada--brampton',
            displayName: 'Brampton',
        },
        {
            locationSlug: 'canada--surrey',
            displayName: 'Surrey',
        },
    ],
    [TLD_UNITED_KINGDOM]: [
        {
            locationSlug: 'united-kingdom--london',
            displayName: 'London',
        },
        {
            locationSlug: 'united-kingdom--manchester',
            displayName: 'Manchester',
        },
        {
            locationSlug: 'united-kingdom--birmingham',
            displayName: 'Birmingham',
        },
        {
            locationSlug: 'united-kingdom--bristol',
            displayName: 'Bristol',
        },
        {
            locationSlug: 'united-kingdom--liverpool',
            displayName: 'Liverpool',
        },
        {
            locationSlug: 'united-kingdom--glasgow',
            displayName: 'Glasgow',
        },
        {
            locationSlug: 'united-kingdom--leeds',
            displayName: 'Leeds',
        },
        {
            locationSlug: 'united-kingdom--edinburgh',
            displayName: 'Edinburgh',
        },
        {
            locationSlug: 'united-kingdom--newcastle-upon-tyne',
            displayName: 'Newcastle Upon Tyne',
        },
        {
            locationSlug: 'united-kingdom--belfast',
            displayName: 'Belfast',
        },
        {
            locationSlug: 'united-kingdom--sheffield',
            displayName: 'Sheffield',
        },
        {
            locationSlug: 'united-kingdom--nottingham',
            displayName: 'Nottingham',
        },
        {
            locationSlug: 'united-kingdom--cardiff',
            displayName: 'Cardiff',
        },
        {
            locationSlug: 'united-kingdom--brighton',
            displayName: 'Brighton',
        },
        {
            locationSlug: 'united-kingdom--cambridge',
            displayName: 'Cambridge',
        },
    ],
    [TLD_AUSTRALIA]: [
        {
            locationSlug: 'australia--melbourne',
            displayName: 'Melbourne',
        },
        {
            locationSlug: 'australia--sydney',
            displayName: 'Sydney',
        },
        {
            locationSlug: 'australia--brisbane-city',
            displayName: 'Brisbane City',
        },
        {
            locationSlug: 'australia--adelaide',
            displayName: 'Adelaide',
        },
        {
            locationSlug: 'australia--gold-coast',
            displayName: 'Gold Coast',
        },
        {
            locationSlug: 'australia--new-south-wales',
            displayName: 'New South Wales',
        },
        {
            locationSlug: 'australia--canberra',
            displayName: 'Canberra',
        },
        {
            locationSlug: 'australia--victoria',
            displayName: 'Victoria',
        },
        {
            locationSlug: 'australia--highgate',
            displayName: 'Highgate',
        },
        {
            locationSlug: 'australia--perth',
            displayName: 'Perth',
        },
        {
            locationSlug: 'australia--queensland',
            displayName: 'Queensland',
        },
        {
            locationSlug: 'australia--hobart',
            displayName: 'Hobart',
        },
        {
            locationSlug: 'australia--newcastle',
            displayName: 'Newcastle',
        },
        {
            locationSlug: 'australia--geelong',
            displayName: 'Geelong',
        },
        {
            locationSlug: 'australia--byron-bay',
            displayName: 'Byron Bay',
        },
    ],
    [TLD_GLOBALLY]: [
        {
            locationSlug: 'ny--new-york',
            displayName: 'New York',
        },
        {
            locationSlug: 'united-kingdom--london',
            displayName: 'London',
        },
        {
            locationSlug: 'ca--los-angeles',
            displayName: 'Los Angeles',
        },
        {
            locationSlug: 'il--chicago',
            displayName: 'Chicago',
        },
        {
            locationSlug: 'canada--toronto',
            displayName: 'Toronto',
        },
        {
            locationSlug: 'dc--washington',
            displayName: 'Washington',
        },
        {
            locationSlug: 'ga--atlanta',
            displayName: 'Atlanta',
        },
        {
            locationSlug: 'ca--san-francisco',
            displayName: 'San Francisco',
        },
        {
            locationSlug: 'fl--miami',
            displayName: 'Miami',
        },
        {
            locationSlug: 'tx--dallas',
            displayName: 'Dallas',
        },
        {
            locationSlug: 'ireland--dublin',
            displayName: 'Dublin',
        },
        {
            locationSlug: 'tx--houston',
            displayName: 'Houston',
        },
        {
            locationSlug: 'nv--las-vegas',
            displayName: 'Las Vegas',
        },
        {
            locationSlug: 'ma--boston',
            displayName: 'Boston',
        },
        {
            locationSlug: 'australia--sydney',
            displayName: 'Sydney',
        },
    ],
};
